export enum KeyStorage {
  AUTH = 'auth',
  THEME = 'theme',
  LANGUAGE = 'i18nextLng',
  LOCALE = 'locale',
  UI_CMS = 'uiCms'
}

const localStorageHelper = {
  set: (key: KeyStorage, value: string): boolean => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {}
    return false;
  },
  setObject: (key: KeyStorage, value: any = {}): boolean => {
    try {
      const newValue = JSON.stringify(value);
      localStorage.setItem(key, newValue);
      return true;
    } catch (error) {}
    return false;
  },
  get: (key: KeyStorage, defaultValue: string | null = null): string | null => {
    const value = localStorage.getItem(key);
    if (value) {
      return value;
    }
    return defaultValue;
  },
  getObject: (key: KeyStorage, defaultValue: any = {}): any => {
    try {
      const value = localStorage.getItem(key);
      if (value) {
        const object = JSON.parse(value);
        return object;
      }
    } catch (error) {}
    return defaultValue;
  },
  remove: (key: KeyStorage) => {
    localStorage.removeItem(key);
  }
};

export default localStorageHelper;
